import { SET_ADMINWALLET } from "../constant";
const initialState = {
    adminWalletAddress: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_ADMINWALLET:
            return { ...state, adminWalletAddress: action.payload };
        default:
            return state;
    }
}